var React = require('react');

function Toolip (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M38.7746 34.8658L20.7932 45.7437C17.8692 47.5177 14.098 46.8026 11.9938 44.0934L3.75462 33.4219L3.49501 33.5731C-0.139527 35.5809 -1.12331 40.3804 1.41813 43.6671L11.9938 57.3779C14.0844 60.087 17.8555 60.8021 20.7932 59.0281L39.7174 47.5864C43.5706 45.2624 44.1171 39.8716 40.8242 36.8049L38.761 34.8796L38.7746 34.8658Z","fill":"#424548","key":0}),React.createElement("path",{"d":"M40.8242 13.4815L28.3219 1.80602C26.1904 -0.174264 23.0341 -0.573072 20.4926 0.843384L3.50868 10.2498C-0.125855 12.2576 -1.10964 17.057 1.4318 20.3437L12.0075 34.0545C14.098 36.7636 17.8692 37.4787 20.8069 35.7047L39.7311 24.2631C43.5843 21.939 44.1308 16.5482 40.8379 13.4815H40.8242Z","fill":"#424548","key":1})]);
}

Toolip.defaultProps = {"width":"43","height":"60","viewBox":"0 0 43 60","fill":"none"};

module.exports = Toolip;

Toolip.default = Toolip;
